import { Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { useAuth } from "./hooks/useAuth";
import { AuthScreen } from "./screens/AuthScreen";
import { DashboardScreen } from "./screens/DashboardScreen";
import { ProfileScreen } from "./screens/ProfileScreen";
import { VacantesScreen } from "./screens/VacantesScreen";
import { LoadingScreen } from "./components/LoadingScreen";
import { InstallPwaPrompt } from "./components/InstallPwaPrompt";
import { PublicRoute } from "./routers/PublicRoute";
import { PrivateRoute } from "./routers/PrivateRoute";
import { WorkerInfoPage } from "./screens/WorkerInfoScreen";
import { RegisterScreen } from "./screens/RegisterScreen";
import { PrivacyPolicyScreen } from "./screens/PrivacyPolicyScreen";
import { InteraccionesMenuScreen } from "./screens/InteraccionesMenuScreen";
import { EscuelaScreen } from "./screens/EscuelaScreen";
import { PublicacionesScreen } from "./screens/PublicacionesScreen";
import { AliadosScreen } from "./screens/AliadosScreen";
import { RedApoyoScreen } from "./screens/RedApoyoScreen";
import { OfertasLaboralesScreen } from "./screens/OfertasLaboralesScreen";
import { FundacionScreen } from "./screens/FundacionScreen";
import { SegurosScreen } from "./screens/SegurosScreen";
import { ModuloItemsScreen } from "./screens/ModuloItemsScreen";
import { CvPreviewScreen } from "./screens/CvPreviewScreen";
import { ExpiredSessionScreen } from "./screens/ExpiredSessionScreen";
function App() {
  const { loading } = useAuth();

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <>
      <Routes>
        <Route
          path="/auth"
          element={
            <PublicRoute>
              <AuthScreen />
            </PublicRoute>
          }
        />
        <Route
          path="/register"
          element={
            <PublicRoute>
              <RegisterScreen />
            </PublicRoute>
          }
        />

        <Route
          path="/wizard"
          element={
            <PrivateRoute>
              <WorkerInfoPage />
            </PrivateRoute>
          }
        />

        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <DashboardScreen />
            </PrivateRoute>
          }
        />

        <Route
          path="/privacy-policy"
          element={
            <PrivateRoute>
              <PrivacyPolicyScreen />
            </PrivateRoute>
          }
        />

        <Route
          path="/vista-previa"
          element={
            <PrivateRoute>
              <CvPreviewScreen />
            </PrivateRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <PrivateRoute>
              <ProfileScreen />
            </PrivateRoute>
          }
        />
        <Route
          path="/interacciones"
          element={
            <PrivateRoute>
              <InteraccionesMenuScreen />
            </PrivateRoute>
          }
        />
        <Route
          path="/interacciones/escuela"
          element={
            <PrivateRoute>
              <EscuelaScreen />
            </PrivateRoute>
          }
        />
        <Route
          path="/interacciones/publicaciones"
          element={
            <PrivateRoute>
              <PublicacionesScreen />
            </PrivateRoute>
          }
        />
        <Route
          path="/interacciones/aliados"
          element={
            <PrivateRoute>
              <AliadosScreen />
            </PrivateRoute>
          }
        />
        <Route
          path="/interacciones/red-apoyo"
          element={
            <PrivateRoute>
              <RedApoyoScreen />
            </PrivateRoute>
          }
        />
        <Route
          path="/interacciones/ofertas-laborales"
          element={
            <PrivateRoute>
              <OfertasLaboralesScreen />
            </PrivateRoute>
          }
        />
        <Route
          path="/interacciones/fundacion"
          element={
            <PrivateRoute>
              <FundacionScreen />
            </PrivateRoute>
          }
        />
        <Route
          path="/interacciones/seguros"
          element={
            <PrivateRoute>
              <SegurosScreen />
            </PrivateRoute>
          }
        />
        <Route
          path="/interacciones/items/:moduleKey"
          element={
            <PrivateRoute>
              <ModuloItemsScreen />
            </PrivateRoute>
          }
        />

        {/* <Route
          path="/vacantes"
          element={
            <PrivateRoute>
              <VacantesScreen />
            </PrivateRoute>
          }
        /> */}

        <Route path="/expired-session" element={<ExpiredSessionScreen />} />
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
      </Routes>

      <Toaster position="bottom-right" richColors />
      <InstallPwaPrompt />
    </>
  );
}

export default App;
